module.exports = __webpack_public_path__ + "static/media/work-style-assessment.57e31820.png";